// Pin a scroller to its newest line. `Element.scrollTo` is NOT universal — jsdom-class engines (the
// SEO crawlers that report a Chrome UA) and some extension-proxied DOMs don't define it, and a throw
// inside a mount effect takes the whole page down through the error boundary. Sentry 7810652177 was
// exactly that: a blank landing page from `el.scrollTo is not a function` in the hero's chat demo.
// `scrollTop` exists everywhere, so it is the fallback.
export function scrollToEnd(el, smooth = false) {
  if (!el) return;
  const top = el.scrollHeight;
  if (smooth && typeof el.scrollTo === "function") {
    el.scrollTo({ top, behavior: "smooth" });
    return;
  }
  if (typeof el.scrollTop === "number") el.scrollTop = top;
}

// `window.scrollTo` and `Element.scrollIntoView` go missing on exactly the same engines. Any page a
// visitor or a link-preview bot can open without logging in goes through these two instead.
export function scrollPageTop() {
  if (typeof window === "undefined") return;
  if (typeof window.scrollTo === "function") { window.scrollTo(0, 0); return; }
  const el = document.scrollingElement || document.documentElement;
  if (el && typeof el.scrollTop === "number") el.scrollTop = 0;
}

export function scrollIntoViewSafe(el, opts = { behavior: "smooth", block: "center" }) {
  if (el && typeof el.scrollIntoView === "function") el.scrollIntoView(opts);
}
